import type { PromoTripWithMap } from "../../../api/admin";
import "./StaticPromoMap.less";

type StaticPromoMapProps = {
  trip: PromoTripWithMap;
  alt: string;
  width: number;
  height: number;
};

export function StaticPromoMap({ trip, alt, width, height }: StaticPromoMapProps) {
  return (
    <img
      src={`/api/promo-trips/${trip.tokenId}/static-map.png?w=${width}&h=${height}`}
      alt={alt}
      loading="lazy"
      className="static-promo-map"
    />
  );
}
